var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from "moment";
import { buildNutritionRequestBody, getDefaultCustomizeOptions, getRecipeNutrition, processSelectedCustomizeOptions, } from "../../../../../Shared/components/CustomizeModal/CustomizeModal-utils";
import { getCurrentCompatibilityType } from "../../../../../Shared/components/ItemCard/utils/itemCardUtils";
import { ItemCardType } from "../../../../../Shared/components/ItemCard/utils/itemcard-types";
import { createRecipeImageArray } from "../../../../../Shared/components/ItemDetail/createRecipeImageArray";
import { clone } from "../../../../../Shared/utils/clone";
import { createKey } from "../../../../../Shared/utils/createKey";
import { ActionTypes } from "../../../../OrderFlowProvider/OrderFlowActionTypes";
import { RecipeSelectionType, RecipeTypeSelectionMode, } from "../../../../OrderFlowProvider/OrderFlowTypes";
import { getMustReplaceIngredients } from "../../../../hooks/RecipeSelection/recipeSelectionUtils";
import { getTemplateDays } from "../../../../utils/orderFlowUtils";
import { applyRecipeModuleFilters } from "../../RecipeFilterModule/recipeFilterModuleUtils";
import { RecipeModuleText, } from "./RecipeModule-Types";
import { setMealsSkippedForDay } from "../../../../OrderFlowProvider/reducerUtils";
/**
 * Adds a recipe assignment to a meal on the selectedDay.
 * This function does not dispatch a store update, it only returns the updated meals.
 * This allows us to reuse this logic for the Recipe module and the Customization modal.
 *
 * @param assignToExistingMeals
 * @param addMeals
 * @param removeMeals
 * @param cartMeals
 * @param program
 * @param modelDeliveryDays
 * @param selectedDay
 * @param recipe
 * @param programMealId
 * @param assignmentId
 * @param createNewAssignment
 * @param setAssignmentId
 * @returns
 */
const incrementRecipe = (assignToExistingMeals, addMeals, removeMeals, cartMeals, program, modelDeliveryDays, selectedDay, recipe, programMealId, assignmentId, createNewAssignment, shouldSetAssignmentId, setAssignmentId) => {
    var _a, _b, _c, _d, _e;
    const recipeName = recipe.RecipeName;
    const recipeShortName = recipe.RecipeShortName;
    const recipeId = recipe.RecipeId;
    let mealPrice = 0;
    //For Klaviyo event
    let mealName = "";
    //For Customization modal
    let disableAddButton = false;
    let currentAssignmentQuantity = 0;
    // Needed to apply default customizations
    let currentRecipeAssignment = undefined;
    const recipeAssignment = recipe.Assignments.find((assignment) => assignment.ProgramMealId === programMealId && moment(assignment.Date).isSame(moment(selectedDay)));
    const mealExists = cartMeals
        ? cartMeals.some((meal) => moment(meal.MealDate).isSame(moment(selectedDay)) && meal.ProgramMealId === programMealId)
        : false;
    if (mealExists) {
        const meals = cartMeals === null || cartMeals === void 0 ? void 0 : cartMeals.map((meal) => {
            var _a, _b, _c, _d, _e, _f, _g;
            if (moment(meal.MealDate).isSame(moment(selectedDay)) && meal.ProgramMealId === programMealId) {
                mealPrice = meal.Price;
                mealName = meal.ProgramMealName;
                let assignment = meal.RecipeAssignments &&
                    meal.RecipeAssignments.find((a) => (a.RecipeId === recipeId && a.ProgramMealId === programMealId && !assignmentId) ||
                        a.AssignmentId === assignmentId);
                const totalAssignmentQuantity = (_b = (_a = meal.RecipeAssignments) === null || _a === void 0 ? void 0 : _a.reduce((total, assignment) => total + assignment.Quantity, 0)) !== null && _b !== void 0 ? _b : 0;
                // un-remove a meal only if we're going to exceed the meal quantity by adding a new assignment
                if (removeMeals &&
                    meal.NumRemovedAssignments &&
                    meal.NumRemovedAssignments > 0 &&
                    totalAssignmentQuantity >= meal.Quantity) {
                    meal.NumRemovedAssignments -= 1;
                }
                if (!assignToExistingMeals) {
                    meal.Quantity += 1;
                }
                else if (addMeals && assignToExistingMeals && totalAssignmentQuantity === meal.Quantity) {
                    meal.Quantity += 1;
                }
                if (!!assignment && !createNewAssignment) {
                    currentRecipeAssignment = assignment;
                    assignment.Quantity += 1;
                    currentAssignmentQuantity = assignment.Quantity;
                    // If the user increments an assignment then it is no longer an automatic selection
                    currentRecipeAssignment.IsAutomaticSelection = false;
                    //Recalculate total to check if meal qty has been met for the customize modal
                    const updatedAssignmentQuantity = (_d = (_c = meal.RecipeAssignments) === null || _c === void 0 ? void 0 : _c.reduce((total, assignment) => total + assignment.Quantity, 0)) !== null && _d !== void 0 ? _d : 0;
                    //If we cant add meals and the meal quantity is met, disable the add button.
                    if (!addMeals && updatedAssignmentQuantity === meal.Quantity) {
                        disableAddButton = true;
                    }
                }
                else {
                    if (!meal.RecipeAssignments) {
                        meal.RecipeAssignments = [];
                    }
                    const recipePrice = (_e = recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.RecipeAssignmentPrice) !== null && _e !== void 0 ? _e : 0;
                    const newAssignmentId = createKey();
                    if (shouldSetAssignmentId) {
                        // Update the assignmentId for customization
                        setAssignmentId(newAssignmentId);
                    }
                    const newAssignment = {
                        RecipeId: recipeId,
                        RecipeName: recipeName,
                        RecipeShortName: recipeShortName,
                        ProgramMealId: programMealId,
                        Date: moment(selectedDay),
                        Quantity: 1,
                        SelectedIngredientOptions: [],
                        RecipePrice: recipePrice,
                        IsAutomaticSelection: false,
                        CompatibilityType: recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.CompatibilityType,
                        AutomaticReplacements: recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.AutomaticReplacements,
                        RecipeAssignmentPrice: recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.RecipeAssignmentPrice,
                        Skips: recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.Skips,
                        AssignmentId: newAssignmentId,
                    };
                    meal.RecipeAssignments.push(newAssignment);
                    const updatedAssignmentQuantity = (_g = (_f = meal.RecipeAssignments) === null || _f === void 0 ? void 0 : _f.reduce((total, assignment) => total + assignment.Quantity, 0)) !== null && _g !== void 0 ? _g : 0;
                    //If we cant add meals and the meal quantity is met, disable the add button.
                    if (!addMeals && updatedAssignmentQuantity === meal.Quantity) {
                        disableAddButton = true;
                    }
                    currentRecipeAssignment = newAssignment;
                    currentAssignmentQuantity = 1;
                }
            }
            return meal;
        });
        return {
            meals,
            currentRecipeAssignment,
            recipeName,
            mealPrice,
            mealName,
            mealDate: moment(selectedDay),
            disableAddButton,
            currentAssignmentQuantity,
        };
    }
    else {
        const programMeal = program.ProgramMeals.find((pm) => pm.ProgramMealId === programMealId);
        const deliveryDate = (_a = modelDeliveryDays.find((dd) => moment(dd.MealDateString).isSame(moment(selectedDay)))) === null || _a === void 0 ? void 0 : _a.ShipDateString;
        const recipePrice = (_b = recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.RecipeAssignmentPrice) !== null && _b !== void 0 ? _b : 0;
        mealPrice = programMeal === null || programMeal === void 0 ? void 0 : programMeal.Price;
        mealName = programMeal === null || programMeal === void 0 ? void 0 : programMeal.ProgramMealName;
        const newAssignmentId = createKey();
        if (shouldSetAssignmentId) {
            // Update the assignmentId for customization
            setAssignmentId(newAssignmentId);
        }
        const newAssignment = {
            Quantity: 1,
            RecipeId: recipeId,
            RecipeName: recipeName,
            RecipeShortName: recipeShortName,
            Date: moment(selectedDay),
            ProgramMealId: programMealId,
            SelectedIngredientOptions: (_c = recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.SelectedIngredientOptions) !== null && _c !== void 0 ? _c : [],
            RecipePrice: recipePrice,
            IsAutomaticSelection: false,
            CompatibilityType: recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.CompatibilityType,
            AutomaticReplacements: recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.AutomaticReplacements,
            RecipeAssignmentPrice: recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.RecipeAssignmentPrice,
            Skips: recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.Skips,
            AssignmentId: newAssignmentId,
        };
        const meals = [
            ...cartMeals,
            {
                MealDate: moment(selectedDay),
                OriginalMealDate: moment(selectedDay),
                DeliveryDate: moment(deliveryDate),
                ProgramMealId: programMealId,
                ProgramMealName: (_d = programMeal === null || programMeal === void 0 ? void 0 : programMeal.MealName) !== null && _d !== void 0 ? _d : "",
                Price: (_e = programMeal === null || programMeal === void 0 ? void 0 : programMeal.Price) !== null && _e !== void 0 ? _e : 0,
                Quantity: 1,
                RecipeAssignments: [newAssignment],
                NumRemovedAssignments: 0,
                MealTypeId: programMeal === null || programMeal === void 0 ? void 0 : programMeal.MealTypeId,
                IsSkipped: false,
            },
        ];
        currentRecipeAssignment = newAssignment;
        currentAssignmentQuantity = 1;
        return {
            meals,
            currentRecipeAssignment,
            recipeName,
            mealPrice,
            mealName,
            mealDate: moment(selectedDay),
            disableAddButton,
            currentAssignmentQuantity,
        };
    }
};
/**
 * Adds a recipe assignment to a meal on the selectedDay.
 * This function updates the CustomizationContext which controls the Customization modal.
 *
 * @param assignToExistingMeals
 * @param addMeals
 * @param removeMeals
 * @param cartMeals
 * @param program
 * @param modelDeliveryDays
 * @param selectedDay
 * @param assignmentId
 * @param setAssignmentId
 * @returns
 */
export const customizeIncrement = (assignToExistingMeals, addMeals, removeMeals, cartMeals, program, modelDeliveryDays, selectedDay, assignmentId, setAssignmentId) => (recipe, programMealId, setMeals, setIsAddDisabled, setQuantity) => (shouldSetAssignmentId) => {
    const clonedCartMeals = clone(cartMeals);
    const { meals, disableAddButton, currentAssignmentQuantity } = incrementRecipe(assignToExistingMeals, addMeals, removeMeals, clonedCartMeals, program, modelDeliveryDays, selectedDay, recipe, programMealId, assignmentId, false, shouldSetAssignmentId, setAssignmentId);
    if (currentAssignmentQuantity === undefined) {
        throw new Error(RecipeModuleText.UpdateError);
    }
    setMeals(meals);
    setIsAddDisabled(!!disableAddButton);
    setQuantity(currentAssignmentQuantity);
};
/**
 * Removes a recipe assignment for a meal on the selectedDay.
 * This function does not dispatch a store update, it only returns the updated meals.
 * This allows us to reuse this logic for the Recipe module and the Customization modal.
 *
 * @param assignToExistingMeals
 * @param removeMeals
 * @param onlyShowDeliveryDays
 * @param cartTemplate
 * @param cartMeals
 * @param cartDaysOfWeek
 * @param selectedDay
 * @param recipe
 * @param programMealId
 * @param assignmentId
 * @returns
 */
export const decrementRecipe = (assignToExistingMeals, removeMeals, onlyShowDeliveryDays, cartTemplate, cartMeals, cartDaysOfWeek, selectedDay, recipe, programMealId, assignmentId) => {
    let mealDate = moment(selectedDay);
    let recipeId = recipe.RecipeId;
    let mealPrice = 0;
    //For Klaviyo event
    let mealName = "";
    //For Customization modal
    let currentAssignmentQuantity = 0;
    const meals = cartMeals
        .map((meal) => {
        if (moment(moment(meal.MealDate)).isSame(mealDate, "date") && meal.ProgramMealId === programMealId) {
            mealPrice = meal.Price;
            mealName = meal.ProgramMealName;
            if (assignToExistingMeals) {
                let templateMeal = cartTemplate.find((meal) => meal.ProgramMealId === programMealId && meal.DayOfWeek === mealDate.day());
                let minMealQuantity = 0;
                if (cartDaysOfWeek.some((day) => day === mealDate.day())) {
                    minMealQuantity = (templateMeal && templateMeal.Quantity) || 0;
                    if (onlyShowDeliveryDays && meal.CoalescedMealDates && meal.CoalescedMealDates.length > 0) {
                        minMealQuantity = GetCoalescedMealQuantity(cartTemplate, meal);
                    }
                }
                if (meal.Quantity > minMealQuantity) {
                    meal.Quantity -= 1;
                }
                else if (removeMeals) {
                    meal.Quantity -= 1;
                    meal.NumRemovedAssignments || (meal.NumRemovedAssignments = 0);
                    meal.NumRemovedAssignments += 1;
                }
            }
            else {
                meal.Quantity -= 1;
            }
            // If we have an assignmentId we need to ensure we grab the one that matches.
            // Otherwise we only care about the other conditions
            let assignment = meal.RecipeAssignments &&
                meal.RecipeAssignments.find((a) => a.RecipeId === recipeId &&
                    a.ProgramMealId === programMealId &&
                    (!!assignmentId ? a.AssignmentId === assignmentId : true));
            if (assignment) {
                assignment.Quantity -= 1;
                currentAssignmentQuantity = assignment.Quantity;
                // If the user decrements an assignment then it is no longer an automatic selection
                assignment.IsAutomaticSelection = false;
            }
        }
        return meal;
    })
        .filter((meal) => removeMeals || (!removeMeals && meal.Quantity > 0));
    return {
        meals,
        mealPrice,
        mealName,
        mealDate: moment(selectedDay),
        currentAssignmentQuantity,
    };
};
/**
 * Removes a recipe assignment for a meal on the selectedDay.
 * This function updates the CustomizationContext which controls the Customization modal.
 * @param assignToExistingMeals
 * @param removeMeals
 * @param onlyShowDeliveryDays
 * @param cartTemplate
 * @param cartMeals
 * @param cartDaysOfWeek
 * @param selectedDay
 * @param assignmentId
 * @returns
 */
export const customizeDecrement = (assignToExistingMeals, removeMeals, onlyShowDeliveryDays, cartTemplate, cartMeals, cartDaysOfWeek, selectedDay, assignmentId) => (recipe, programMealId, setMeals, setIsAddDisabled, setQuantity) => {
    const clonedCartMeals = clone(cartMeals);
    const { meals, currentAssignmentQuantity } = decrementRecipe(assignToExistingMeals, removeMeals, onlyShowDeliveryDays, cartTemplate, clonedCartMeals, cartDaysOfWeek, selectedDay, recipe, programMealId, assignmentId);
    setMeals(meals);
    setQuantity(currentAssignmentQuantity);
    //Add will always be enabled after decrementing
    setIsAddDisabled(false);
};
/**
 * Increment the quantity of a recipe assignment for a meal. Immediately dispatches and updates the store.
 *
 * @param assignToExistingMeals
 * @param addMeals
 * @param removeMeals
 * @param cartMeals
 * @param program
 * @param modelDeliveryDays
 * @param sku
 * @param companyUsesKlaviyo
 * @param dispatch
 * @param createKlaviyoEvent
 * @param logReactPixel
 * @param selectedDay
 * @param pixelKey
 * @returns
 */
export const HandleRecipeIncrement = (assignToExistingMeals, addMeals, removeMeals, cartMeals, recipes, program, modelDeliveryDays, sku, companyUsesKlaviyo, dispatch, createKlaviyoEvent, logReactPixel, selectedDay, dataDogLog, pixelKey) => (recipe, programMealId, setMeals, setAssignmentId) => (createNewAssignment, shouldSetAssignmentId) => __awaiter(void 0, void 0, void 0, function* () {
    const clonedCartMeals = clone(cartMeals);
    const { meals, currentRecipeAssignment, mealPrice, mealName, mealDate } = incrementRecipe(assignToExistingMeals, addMeals, removeMeals, clonedCartMeals, program, modelDeliveryDays, selectedDay, recipe, programMealId, undefined, createNewAssignment, shouldSetAssignmentId, setAssignmentId);
    const { ingredientsToReplace } = getMustReplaceIngredients(recipe);
    if (ingredientsToReplace && ingredientsToReplace.length > 0) {
        const { options } = getDefaultCustomizeOptions(ingredientsToReplace, recipe, currentRecipeAssignment);
        const nutrition = yield getRecipeNutrition(recipe.RecipeId, buildNutritionRequestBody(options, recipe), dataDogLog);
        // Default customizations need to be applied when the recipe quantity is incremented
        HandleCustomizeSubmit(recipes, selectedDay, dispatch)(recipe.RecipeId, programMealId, setMeals)(options, meals, undefined, currentRecipeAssignment, nutrition);
    }
    else {
        setMeals(meals);
        dispatch({ type: ActionTypes.SET_MEALS, payload: meals });
    }
    if (companyUsesKlaviyo) {
        let totalQuantity = 0;
        const mealsForKlaviyo = meals.filter((meal) => moment(meal.MealDate).isSame(moment(mealDate)) &&
            meal.ProgramMealId === programMealId &&
            meal.RecipeAssignments);
        mealsForKlaviyo.forEach((meal) => {
            var _a, _b, _c;
            totalQuantity +=
                (_c = (_b = (_a = meal === null || meal === void 0 ? void 0 : meal.RecipeAssignments) === null || _a === void 0 ? void 0 : _a.filter((ra) => ra.RecipeId === (recipe === null || recipe === void 0 ? void 0 : recipe.RecipeId))) === null || _b === void 0 ? void 0 : _b.reduce((accum, ra) => accum + ra.Quantity, 0)) !== null && _c !== void 0 ? _c : 0;
        });
        const eventInfo = {
            RecipeName: recipe.RecipeName,
            Quantity: totalQuantity,
            MealName: mealName,
            SKU: sku,
            DayOfWeek: moment(recipe.AvailableOn).format("ddd"),
        };
        createKlaviyoEvent("Added Recipe", eventInfo);
    }
    if (pixelKey) {
        const data = {
            content_name: recipe.RecipeName,
            content_ids: recipe.RecipeId,
            content_type: "meal",
            value: mealPrice,
            currency: "USD",
        };
        logReactPixel("AddMeal", data);
    }
});
/**
 * Decrement the quantity of a recipe assignment for a meal. Immediately dispatches and updates the store.
 *
 * @param assignToExistingMeals
 * @param removeMeals
 * @param onlyShowDeliveryDays
 * @param cartTemplate
 * @param cartMeals
 * @param cartDaysOfWeek
 * @param sku
 * @param companyUsesKlaviyo
 * @param cartSelectedDay
 * @param dispatch
 * @param createKlaviyoEvent
 * @param logReactPixel
 * @param assignmentId
 * @param pixelKey
 * @returns
 */
export const HandleRecipeDecrement = (assignToExistingMeals, removeMeals, onlyShowDeliveryDays, cartTemplate, cartMeals, cartDaysOfWeek, sku, companyUsesKlaviyo, cartSelectedDay, dispatch, createKlaviyoEvent, logReactPixel, assignmentId, pixelKey) => (recipe, programMealId) => {
    const clonedCartMeals = clone(cartMeals);
    const { meals, mealPrice, mealName, mealDate } = decrementRecipe(assignToExistingMeals, removeMeals, onlyShowDeliveryDays, cartTemplate, clonedCartMeals, cartDaysOfWeek, cartSelectedDay, recipe, programMealId, assignmentId);
    if (companyUsesKlaviyo) {
        let totalQuantity = 0;
        const mealsForKlaviyo = meals.filter((meal) => moment(meal.MealDate).isSame(moment(mealDate)) &&
            meal.ProgramMealId === programMealId &&
            meal.RecipeAssignments);
        mealsForKlaviyo.forEach((meal) => {
            var _a, _b, _c;
            totalQuantity +=
                (_c = (_b = (_a = meal === null || meal === void 0 ? void 0 : meal.RecipeAssignments) === null || _a === void 0 ? void 0 : _a.filter((ra) => ra.RecipeId === recipe.RecipeId)) === null || _b === void 0 ? void 0 : _b.reduce((accum, ra) => accum + ra.Quantity, 0)) !== null && _c !== void 0 ? _c : 0;
        });
        const eventInfo = {
            RecipeName: recipe.RecipeName,
            Quantity: totalQuantity,
            MealName: mealName,
            SKU: sku,
            DayOfWeek: moment(recipe.AvailableOn).format("ddd"),
        };
        createKlaviyoEvent("Removed Recipe", eventInfo);
    }
    if (pixelKey) {
        const data = {
            content_name: recipe.RecipeName,
            content_ids: recipe.RecipeId,
            content_type: "meal",
            value: mealPrice,
            currency: "USD",
        };
        logReactPixel("RemoveMeal", data);
    }
    dispatch({ type: ActionTypes.SET_MEALS, payload: meals });
};
/**
 * Dispatches SET_MEALS to update recipe assignments with selected customizations
 *
 * @param recipes
 * @param selectedDay
 * @param dispatch
 * @param toast
 * @returns
 */
export const HandleCustomizeSubmit = (recipes, selectedDay, dispatch) => (recipeId, programMealId, setMeals) => (selectedCustomizeOptions, meals, days, assignment, nutrition) => {
    if (!meals)
        return;
    const targetRecipe = recipes.find((r) => r.RecipeId === recipeId &&
        r.Assignments.some((a) => a.ProgramMealId === programMealId && moment(a.Date).isSame(moment(selectedDay), "date")));
    const newMeals = meals.map((meal) => {
        var _a;
        if (moment(meal.MealDate).isSame(moment(selectedDay)) && meal.ProgramMealId === programMealId) {
            //Find the specific assignment for customization
            const recipeAssignment = (_a = meal === null || meal === void 0 ? void 0 : meal.RecipeAssignments) === null || _a === void 0 ? void 0 : _a.find((r) => r.RecipeId === recipeId && r.AssignmentId === (assignment === null || assignment === void 0 ? void 0 : assignment.AssignmentId));
            // If the assignment exists use that one. If it doesn't use the new assignment
            const recipeAssignmentToUse = recipeAssignment !== null && recipeAssignment !== void 0 ? recipeAssignment : assignment;
            //If we have an assignment clear its previous selections
            if (recipeAssignmentToUse && recipeAssignmentToUse.Quantity > 0) {
                recipeAssignmentToUse.SelectedIngredientOptions = [];
                recipeAssignmentToUse.Nutrition = nutrition;
            }
            const { ingredientsToReplace } = getMustReplaceIngredients(targetRecipe);
            processSelectedCustomizeOptions(selectedCustomizeOptions, ingredientsToReplace, recipeAssignmentToUse);
        }
        return meal;
    });
    setMeals(newMeals);
    dispatch({ type: ActionTypes.SET_MEALS, payload: newMeals });
};
/**
 * Calculates the total quantity of a meal based on its coalesced meal dates
 * and a given template.
 *
 * @param {Cart["template"]} template - The template array containing details about days of the week and quantities.
 * @param {Meal} meal - The meal object with coalesced meal dates.
 * @returns {number} - The total quantity of the meal based on matching days in the template.
 */
export const GetCoalescedMealQuantity = (template, meal) => {
    // Filter the template to find days that match the meal's coalesced meal dates.
    const coalescedTemplateDays = template.filter((t) => { var _a; return (_a = meal === null || meal === void 0 ? void 0 : meal.CoalescedMealDates) === null || _a === void 0 ? void 0 : _a.find((cmd) => moment(cmd).day() === t.DayOfWeek && meal.ProgramMealId === t.ProgramMealId); });
    // Sum up the quantities of the filtered template days.
    const coalescedTemplateQuantity = coalescedTemplateDays.reduce((total, t) => total + t.Quantity, 0);
    // Return the total quantity.
    return coalescedTemplateQuantity;
};
/**
 * Ensures assignments do not exceed meal quantity unless configured otherwise
 *
 * @param meals
 * @param enableAddMeals
 * @returns
 */
export const reconcileMeals = (meals, enableAddMeals) => {
    meals.forEach((meal) => {
        let assignments = meal.RecipeAssignments;
        let assignmentQuantity = meal.Quantity;
        let currQty = (assignments && assignments.reduce((quantity, selection) => { var _a; return quantity + ((_a = selection === null || selection === void 0 ? void 0 : selection.Quantity) !== null && _a !== void 0 ? _a : 0); }, 0)) ||
            meal.Quantity;
        // if adding meals is not enabled, ensure that we don't have more meals added than allowed
        if (!enableAddMeals && assignments && currQty > assignmentQuantity) {
            // Each meal can only have up to assigned quantity
            assignments === null || assignments === void 0 ? void 0 : assignments.forEach((selection) => {
                selection.Quantity = Math.min(assignmentQuantity, selection.Quantity);
            });
            // reduce meal quantities until we have as much added as allowed
            currQty = assignments.reduce((quantity, selection) => { var _a; return quantity + ((_a = selection === null || selection === void 0 ? void 0 : selection.Quantity) !== null && _a !== void 0 ? _a : 0); }, 0);
            while (currQty > assignmentQuantity) {
                // remove assignment if quantity is zero
                assignments[0].Quantity -= 1;
                if (assignments[0].Quantity <= 0) {
                    assignments.shift();
                }
                currQty = assignments.reduce((quantity, selection) => { var _a; return quantity + ((_a = selection === null || selection === void 0 ? void 0 : selection.Quantity) !== null && _a !== void 0 ? _a : 0); }, 0);
            }
        }
        meal.RecipeAssignments = assignments && (assignments === null || assignments === void 0 ? void 0 : assignments.length) > 0 ? assignments : undefined;
        meal.Quantity = Math.max(currQty, assignmentQuantity);
    });
    return meals;
};
/**
 * Filter the program meals so only the appropriate meals display on the Recipe module
 *
 * @param programMeals
 * @param moduleProgramMeals
 * @param mealSize
 * @param allMealSizeOption
 * @param enableAddMeals
 * @param cartMeals
 * @param selectedDay
 * @returns
 */
export const getProgramMealsToRender = (programMeals, moduleProgramMeals, mealSize, allMealSizeOption, enableAddMeals, cartMeals, selectedDay) => programMeals.filter((programMeal) => {
    //Only show meals defined on the Recipe module
    if (!moduleProgramMeals.includes(programMeal.ProgramMealId)) {
        return false;
    }
    //If we have a meal size and its not ALL, filter recipes based on that
    if ((mealSize === null || mealSize === void 0 ? void 0 : mealSize.Size) !== allMealSizeOption && programMeal.RecipeSizeId !== (mealSize === null || mealSize === void 0 ? void 0 : mealSize.RecipeSizeId)) {
        return false;
    }
    //If we're not adding meals, display meal only if it's in cart for the selected day
    if (!enableAddMeals) {
        if (cartMeals.length > 0) {
            return cartMeals.some((meal) => meal.ProgramMealId === programMeal.ProgramMealId &&
                moment(meal.MealDate).isSame(moment(selectedDay), "date"));
        }
        else {
            return false;
        }
    }
    return true;
});
/**
 * A recipe can be assigned to one or many days.
 * Look through each assignment to find the one for the correct date and correct meal.
 * Then filter by recipe type if applicable
 * @param recipes
 * @param programMeal
 * @param selectedDay
 * @param recipeType
 * @param recipeTypeSelectionMode
 * @param filterState
 * @returns
 */
export const getRecipesToRender = (recipes, programMeal, selectedDay, recipeType, recipeTypeSelectionMode, filterState) => recipes
    .filter((recipe) => 
// Apply the filters from the recipeFilterModule
applyRecipeModuleFilters(recipe, filterState))
    .filter((recipe) => {
    return recipe.Assignments.find((assignment) => assignment.ProgramMealId === programMeal.ProgramMealId &&
        moment(assignment.Date).isSame(moment(selectedDay), "date"));
})
    .filter((recipe) => {
    //use all recipe option to explicity show all recipes if present and selected
    if (recipeType && recipeType.isAllRecipeType) {
        return true;
    }
    const shouldFilter = recipeTypeSelectionMode === RecipeTypeSelectionMode.Filter ||
        recipeTypeSelectionMode === RecipeTypeSelectionMode.FilterAndSelection;
    if (shouldFilter && recipeType) {
        return recipe.RecipeTypeNames.includes(recipeType.recipeTypeName);
    }
    return true;
});
/**
 * Find the recipe assignment(s) for a meal on the selectedDay
 *
 * @param recipes
 * @param mealForDay
 * @param programMeal
 * @param selectedDay
 * @param recipeType
 * @param templateMealQuantity
 * @param assignmentQuantityForMeal
 * @param assignmentsComplete
 * @param enableAddMeals
 * @param enableAssignRecipes
 * @param enableRemoveMeals
 * @param isSingleRecipeSelectMode
 * @param moduleConfig
 * @param recipeIngredientReplacementMode
 * @param formatPrice
 * @returns
 */
export const getRecipesForMeal = (recipes, mealForDay, programMeal, selectedDay, recipeType, omissions, assignmentQuantityForMeal, enableAddMeals, enableAssignRecipes, isSingleRecipeSelectMode, moduleConfig, cardLayoutSettings, recipeIngredientReplacementMode, formatPrice, isCustomizeModalOpen, setIsCustomizeModalOpen) => recipes.map((recipe) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const mealAssignments = mealForDay &&
        mealForDay.RecipeAssignments &&
        mealForDay.RecipeAssignments.filter((assignment) => assignment.ProgramMealId === programMeal.ProgramMealId && assignment.RecipeId === recipe.RecipeId);
    //Customized plus non-customized recipe assignments
    //This is what displays on the item card
    const totalAssignmentQuantity = (_a = mealAssignments === null || mealAssignments === void 0 ? void 0 : mealAssignments.reduce((total, meal) => total + meal.Quantity, 0)) !== null && _a !== void 0 ? _a : 0;
    const recipeAssignment = recipe.Assignments.find((assignment) => assignment.ProgramMealId === programMeal.ProgramMealId && moment(assignment.Date).isSame(selectedDay));
    // Adding recipes to a meal is disabled if the configuration is disabled AND
    // if we have no meal or
    // if the assignment quantity is equal to the meal quantity(all recipes selected)
    const isAddRecipeDisabled = !enableAddMeals && (!mealForDay || assignmentQuantityForMeal === mealForDay.Quantity);
    const isMinusRecipeDisabled = false;
    const isSelectDisabled = isSingleRecipeSelectMode && enableAddMeals && enableAssignRecipes && (!mealForDay || mealForDay.Quantity === 0);
    const { ingredientsToReplace } = getMustReplaceIngredients(recipe);
    let recipePrice = (_b = recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.RecipeAssignmentPrice) !== null && _b !== void 0 ? _b : 0;
    //If meal quantity is less than recipe quantity apply programMealPrice + recipeTypeUpcharge
    if (mealForDay && (mealForDay === null || mealForDay === void 0 ? void 0 : mealForDay.Quantity) < recipe.Quantity) {
        const recipeTypeUpcharge = recipeType && recipeType.recipeTypePrice ? recipeType.recipeTypePrice : 0;
        recipePrice = programMeal.Price + recipeTypeUpcharge;
    }
    const itemPriceObject = formatPrice({
        recipePrice: recipePrice,
        programMealPrice: programMeal.Price,
        assignmentQuantityForMeal: assignmentQuantityForMeal,
        mealQuantity: mealForDay === null || mealForDay === void 0 ? void 0 : mealForDay.Quantity,
        recipeModuleConfig: moduleConfig,
        shouldUseRecipePricing: programMeal.RecipePricing,
    });
    const recipeImageUrls = createRecipeImageArray(recipe.RecipeImageUrls);
    const assignmentForDay = recipe.Assignments.find((assignment) => assignment.ProgramMealId === programMeal.ProgramMealId &&
        moment(assignment.Date).isSame(moment(selectedDay), "date"));
    const { compatibilityType } = getCurrentCompatibilityType(recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.CompatibilityType, ((_d = (_c = recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.SelectedIngredientOptions) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0 && ((_e = recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.Quantity) !== null && _e !== void 0 ? _e : 0) > 0, ingredientsToReplace, omissions.map((o) => o.dislikeId), recipeIngredientReplacementMode, !!(ingredientsToReplace === null || ingredientsToReplace === void 0 ? void 0 : ingredientsToReplace.length), cardLayoutSettings, moduleConfig.RecipeAutoSelection);
    const totalAssignmentCount = (_f = mealAssignments === null || mealAssignments === void 0 ? void 0 : mealAssignments.length) !== null && _f !== void 0 ? _f : 0;
    // If there's exactly one recipe assignment, use its AssignmentId.
    // This ensures that the single assignment is used in the customize modal.
    // If there are zero or multiple assignments, no assignmentId is set
    const assignmentId = totalAssignmentCount === 1 ? (_g = mealAssignments === null || mealAssignments === void 0 ? void 0 : mealAssignments[0]) === null || _g === void 0 ? void 0 : _g.AssignmentId : undefined;
    const recipeForMeal = Object.assign(Object.assign({}, recipe), { ProgramMealId: (_h = assignmentForDay === null || assignmentForDay === void 0 ? void 0 : assignmentForDay.ProgramMealId) !== null && _h !== void 0 ? _h : programMeal.ProgramMealId, AvailableQuantity: assignmentForDay === null || assignmentForDay === void 0 ? void 0 : assignmentForDay.AvailableQuantity, 
        //Set here for use in increment and decrement functions
        AvailableOn: moment(assignmentForDay.Date).format() });
    return {
        recipe: recipeForMeal,
        cardProps: {
            offMenuRecipe: false,
            itemName: recipe.RecipeName,
            itemShortName: recipe.RecipeShortName,
            itemDescription: recipe.RecipeDescription,
            itemChips: recipe.RecipeTypeNames,
            nutritionMacro: recipe.NutritionMacro,
            nutritionLabelImage: recipe.NutritionalLabelImageUrl,
            itemIngredients: [...new Set(recipe.RecipeIngredients)],
            quantity: totalAssignmentQuantity,
            isAddDisabled: isAddRecipeDisabled,
            isMinusDisabled: isMinusRecipeDisabled,
            isCustomizeDisabled: false,
            isSingleRecipeSelectMode,
            isSelectDisabled,
            singleRecipeSelectedText: moduleConfig.SingleRecipeSelectionSelectedText,
            singleRecipeUnselectedText: moduleConfig.SingleRecipeSelectionUnselectedText,
            conflicts: recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.Conflicts,
            skips: recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.Skips,
            compatibilityType,
            ingredientsToReplace,
            itemImageUrls: recipeImageUrls,
            recipeId: recipe.RecipeId,
            changeRank: recipe.ChangeRank,
            itemPriceObject,
            recipeFlags: recipe.RecipeFlags,
            recipeSelectionType: moduleConfig.RecipeSelectionType,
            itemType: ItemCardType.Recipe,
            recipeIngredientReplacementMode: recipeIngredientReplacementMode,
            recipe: recipeForMeal,
            programMealId: programMeal.ProgramMealId,
            assignmentId: assignmentId,
            assignmentCount: totalAssignmentCount,
            isCustomizeModalOpen,
            setIsCustomizeModalOpen,
        },
    };
});
/**
 * Groups the meal and its recipes
 *
 * @param programMealsToRender
 * @param store
 * @param filterState
 * @param moduleConfig
 * @param enableAssignRecipes
 * @param enableAddMeals
 * @param enableRemoveMeals
 * @param formatPrice
 * @returns
 */
const groupMealsWithRecipesHelper = (programMealsToRender, store, filterState, moduleConfig, enableAssignRecipes, enableAddMeals, enableRemoveMeals, formatPrice, isCustomizeModalOpen, setIsCustomizeModalOpen) => programMealsToRender.map((programMeal) => {
    var _a, _b, _c, _d, _e, _f;
    const mealForDay = store.cart.meals.find((meal) => meal.ProgramMealId === programMeal.ProgramMealId &&
        moment(meal.MealDate).isSame(moment(store.cart.selectedDay), "date"));
    const recipes = getRecipesToRender(store.model.Recipes, programMeal, store.cart.selectedDay, store.cart.recipeType, store.model.recipeTypeSelectionMode, filterState);
    const assignmentQuantityForMeal = mealForDay && mealForDay.RecipeAssignments
        ? mealForDay.RecipeAssignments.reduce((total, assignment) => total + assignment.Quantity, 0)
        : 0;
    const filteredTemplateDays = getTemplateDays(store.cart.daysOfWeek, store.cart.startDate, store.cart.dayQuantity);
    // store.cart.template includes all days, unrestricted by start date, day quantity, or days of the week.
    // We use templateDays to filter and ensure templateMeal aligns with the restricted template based on these criteria.
    const templateMeal = store.cart.template.find((templateMeal) => programMeal.ProgramMealId === templateMeal.ProgramMealId &&
        templateMeal.DayOfWeek === moment(store.cart.selectedDay).day() &&
        filteredTemplateDays.includes(moment(store.cart.selectedDay).day()));
    let templateMealQuantity = (_a = templateMeal === null || templateMeal === void 0 ? void 0 : templateMeal.Quantity) !== null && _a !== void 0 ? _a : 0;
    if (store.model.GeneralSettings.OnlyShowDeliveryDays &&
        (mealForDay === null || mealForDay === void 0 ? void 0 : mealForDay.CoalescedMealDates) &&
        mealForDay.CoalescedMealDates.length > 0) {
        templateMealQuantity = GetCoalescedMealQuantity(store.cart.template, mealForDay);
    }
    const assignmentsComplete = assignmentQuantityForMeal > 0 && assignmentQuantityForMeal === (mealForDay === null || mealForDay === void 0 ? void 0 : mealForDay.Quantity);
    let totalAddedMeals = (assignmentsComplete && Math.abs(assignmentQuantityForMeal - templateMealQuantity)) || 0;
    if (enableRemoveMeals) {
        const numSelected = (mealForDay === null || mealForDay === void 0 ? void 0 : mealForDay.Quantity) || 0;
        const numRemoved = (mealForDay === null || mealForDay === void 0 ? void 0 : mealForDay.NumRemovedAssignments) || 0;
        if (numSelected + numRemoved < templateMealQuantity) {
            totalAddedMeals = 0;
        }
        else {
            totalAddedMeals -= numRemoved;
        }
        if (totalAddedMeals < 0) {
            totalAddedMeals = 0;
        }
    }
    const recipesForMeal = getRecipesForMeal(recipes, mealForDay, programMeal, store.cart.selectedDay, store.cart.recipeType, store.cart.omissions, assignmentQuantityForMeal, enableAddMeals, enableAssignRecipes, Boolean(((_b = moduleConfig === null || moduleConfig === void 0 ? void 0 : moduleConfig.SingleRecipeSelectionModeLimit) === null || _b === void 0 ? void 0 : _b.NumericValue) !== undefined), moduleConfig, store.model.ProductAndRecipeCardLayoutSettings, store.model.OrderFlowSettings.RecipeIngredientReplacementMode, formatPrice, isCustomizeModalOpen, setIsCustomizeModalOpen);
    return {
        meal: {
            ProgramMealId: (_c = mealForDay === null || mealForDay === void 0 ? void 0 : mealForDay.ProgramMealId) !== null && _c !== void 0 ? _c : programMeal.ProgramMealId,
            ProgramMealName: (_d = mealForDay === null || mealForDay === void 0 ? void 0 : mealForDay.ProgramMealName) !== null && _d !== void 0 ? _d : programMeal.MealName,
            Quantity: (_e = mealForDay === null || mealForDay === void 0 ? void 0 : mealForDay.Quantity) !== null && _e !== void 0 ? _e : programMeal.Quantity,
            NumRemovedAssignments: mealForDay === null || mealForDay === void 0 ? void 0 : mealForDay.NumRemovedAssignments,
            IsSkipped: (_f = mealForDay === null || mealForDay === void 0 ? void 0 : mealForDay.IsSkipped) !== null && _f !== void 0 ? _f : false,
        },
        templateMealQuantity,
        assignmentQuantityForMeal,
        assignmentsComplete,
        totalAddedMeals,
        recipesForMeal,
    };
});
/**
 * Returns all program meals and recipes to be displayed on the recipe module as well as the cardProps for each recipe.
 *
 * @param store
 * @param moduleProgramMeals
 * @param filterState
 * @param moduleConfig
 * @param enableAssignRecipes
 * @param enableAddMeals
 * @param enableRemoveMeals
 * @param formatPrice
 * @returns
 */
export const getProgramMealsWithRecipes = (store, moduleProgramMeals, filterState, moduleConfig, enableAssignRecipes, enableAddMeals, enableRemoveMeals, formatPrice, isCustomizeModalOpen, setIsCustomizeModalOpen, recipeSelectionType) => {
    const { cart, model } = store;
    const { mealSize, meals, selectedDay } = cart;
    const { allMealSizeOption, Program } = model;
    const programMealsToRender = getProgramMealsToRender(Program.ProgramMeals, moduleProgramMeals, mealSize, allMealSizeOption, enableAddMeals, meals, selectedDay);
    const programMealsWithRecipes = groupMealsWithRecipesHelper(programMealsToRender, store, filterState, moduleConfig, enableAssignRecipes, enableAddMeals, enableRemoveMeals, formatPrice, isCustomizeModalOpen, setIsCustomizeModalOpen);
    const sortedProgramMealsWithRecipes = sortProgramMealsWithRecipes(recipeSelectionType, programMealsWithRecipes);
    return sortedProgramMealsWithRecipes;
};
/**
 * Sort meals so that meals with a quantity display before those without. It then follows meal sequencing.
 *
 * @param recipeSelectionType
 * @param programMealsWithRecipes
 * @returns
 */
export function sortProgramMealsWithRecipes(recipeSelectionType, programMealsWithRecipes) {
    if (recipeSelectionType === RecipeSelectionType.Both) {
        const mealSequencesDict = {};
        programMealsWithRecipes.forEach((programMeal, idx) => {
            var _a;
            if (!!((_a = programMeal.meal) === null || _a === void 0 ? void 0 : _a.ProgramMealId)) {
                mealSequencesDict[programMeal.meal.ProgramMealId] = idx;
            }
        });
        //program meals that had quantities previously selected are placed at the beginning and the overall order is sorted by their sequence configuration
        programMealsWithRecipes.sort((programMealA, programMealB) => {
            var _a, _b, _c, _d, _e, _f;
            const programAOriginalOrder = (_c = mealSequencesDict[(_b = (_a = programMealA.meal) === null || _a === void 0 ? void 0 : _a.ProgramMealId) !== null && _b !== void 0 ? _b : -1]) !== null && _c !== void 0 ? _c : 0;
            const programBOriginalOrder = (_f = mealSequencesDict[(_e = (_d = programMealB.meal) === null || _d === void 0 ? void 0 : _d.ProgramMealId) !== null && _e !== void 0 ? _e : -1]) !== null && _f !== void 0 ? _f : 0;
            return (Number(programMealB.templateMealQuantity > 0) - Number(programMealA.templateMealQuantity > 0) ||
                programAOriginalOrder - programBOriginalOrder);
        });
    }
    return programMealsWithRecipes;
}
export const restoreMeals = (dispatch, meals, selectedDay) => () => {
    setMealsSkippedForDay(dispatch, meals, selectedDay, false);
};
